export default __webpack_public_path__ + "static/media/icon-card-uplift-general.3ca41eec.svg";